var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.517 0H2.4v6.223h6.117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.308 24v-9.486h7.414V24h5.902V0h-5.902v9.386H2.4V24Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHIcon);
export default __webpack_public_path__ + "static/media/HIcon.44aea4db27605805464cc688cc1bb7ca.svg";
export { ForwardRef as ReactComponent };